export enum FulfillmentStagesEnum {
    VISTA_LAST_LOOK = 'Vista Last Look',
    RTP_OPERATOR = 'RTP Operator',
    SEND_TO_MARKETPLACE = 'Send to Marketplace',
}